module.exports = __webpack_public_path__ + "static/donburivege-28c3c418132f496465962b1988246416.jpg";